<template>
  <div>
    <div class="display">
      <ButtonOutlined
      class="mb-2"
      @click.native="$router.push({
            name: 'Pong'
          })"
      text="Pong"
      />
    <ButtonOutlined
    class="mb-2"
    @click.native="$router.push({
      name: 'Minesweeper'
    })"
    text="Minesweeper"
    />
  </div>
  <router-view/>
</div>
</template>

<script>
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';

export default {
  components: {
    ButtonOutlined,
  },

  data: () => ({
    x_cnt: 16,
    y_cnt: 16,
    bomb_cnt: 32,
    is_first: true,
    is_game_over: false,
    flag_cnt: 0,
    check_cnt: 0,
    field_model: {
      x: -1,
      y: -1,
      is_bomb: false,
      neighbors: [],
      is_checked: false,
      is_flagged: false,
      is_questioned: false,
      display: '',
    },
    fields: [],
    colors: ['#0100FF', '#007E00', '#FD0000', '#000080', '#800000', '#008080', '#000000', '008080'],
  }),

  methods: {
    debug() {
      console.log(this.x_cnt * this.y_cnt);
      console.log(this.check_cnt);
      console.log(this.bomb_cnt);
    },

    init() {
      this.is_first = true;
      this.is_game_over = false;
      this.flag_cnt = 0;
      this.check_cnt = 0;
      this.fields = [];

      for (let i = 0; i < this.x_cnt * this.y_cnt; i++) {
        let field = JSON.parse(JSON.stringify(this.field_model));
        field.x = i % this.x_cnt;
        field.y = parseInt(i / this.x_cnt);
        this.fields.push(field);
      }
      this.setNeighbors();
    },

    setNeighbors() {
      for (let i = 0; i < this.fields.length; i++) {
        let field = this.fields[i];
        let field_list = [];

        let pos_orig = { x: field.x, y: field.y };
        let pos_curr;

        for (let j = 0; j < this.fields.length; j++) {
          pos_curr = { x: this.fields[j].x, y: this.fields[j].y };
          // 8 possible cases
          if (pos_orig.x - 1 == pos_curr.x && pos_orig.y == pos_curr.y)
            field_list.push(j); // ←
          if (pos_orig.x + 1 == pos_curr.x && pos_orig.y == pos_curr.y)
            field_list.push(j); // →
          if (pos_orig.x == pos_curr.x && pos_orig.y - 1 == pos_curr.y)
            field_list.push(j); // ↓
          if (pos_orig.x == pos_curr.x && pos_orig.y + 1 == pos_curr.y)
            field_list.push(j); // ↑
          if (pos_orig.x - 1 == pos_curr.x && pos_orig.y + 1 == pos_curr.y)
            field_list.push(j); // ↖
          if (pos_orig.x + 1 == pos_curr.x && pos_orig.y + 1 == pos_curr.y)
            field_list.push(j); // ↗
          if (pos_orig.x + 1 == pos_curr.x && pos_orig.y - 1 == pos_curr.y)
            field_list.push(j); // ↘
          if (pos_orig.x - 1 == pos_curr.x && pos_orig.y - 1 == pos_curr.y)
            field_list.push(j); // ↙

          if (field_list.length >= 8)
            break;
        }

        field.neighbors = field_list;
      }
    },

    setBombs(index) {
      if (this.bomb_cnt > this.x_cnt * this.y_cnt) {
        this.fields[index].is_bomb = true;
      }

      let bomb_indices = [];
      bomb_indices.push(index);

      while (bomb_indices.length < this.bomb_cnt + 1) {
        let rnd = Math.floor(Math.random() * this.x_cnt * this.y_cnt);
        if (!bomb_indices.includes(rnd)) {
          bomb_indices.push(rnd);
        }
      }

      bomb_indices.shift();
      for (let i = 0; i < bomb_indices.length; i++) {
        this.fields[bomb_indices[i]].is_bomb = true;
      }
    },

    checkNeighbors(field) {
      let neighbor;
      for (let i = 0; i < field.neighbors.length; i++) {
        neighbor = this.fields[field.neighbors[i]];
        if (!neighbor.is_checked) {
          neighbor.is_checked = true;

          let bombs = 0;
          for (let j = 0; j < neighbor.neighbors.length; j++) {
            if (this.fields[neighbor.neighbors[j]].is_bomb)
              bombs++;
          }

          neighbor.display = bombs === 0 ? '' : bombs;

          if (bombs === 0)
            this.checkNeighbors(neighbor);

          if (neighbor.is_flagged) {
            neighbor.is_flagged = false;
            this.flag_cnt--;
          }

          this.check_cnt++;
        }
      }
    },

    performAction(index) {
      if (this.is_game_over)
        return;

      let field = this.fields[index];

      if (field.is_flagged || field.is_questioned)
        return;

      if (this.is_first) {
        this.setBombs(index);
        this.is_first = false;
      }

      if (field.is_bomb) {
        this.is_game_over = 'lose';
      }

      else if(!field.is_checked) {
        field.is_checked = true;

        let bombs = 0;
        for (let j = 0; j < field.neighbors.length; j++) {
          if (this.fields[field.neighbors[j]].is_bomb)
            bombs++;
        }

        field.display = bombs === 0 ? '' : bombs;

        if (bombs === 0)
          this.checkNeighbors(field);

        this.check_cnt++;
      }

      if (this.x_cnt * this.y_cnt === this.check_cnt + this.bomb_cnt) {
        this.is_game_over = 'win';
      }
    },

    performAltAction(index) {
      let field = this.fields[index];
      if (!field.is_checked && !this.is_game_over) {
        if (!field.is_flagged && !field.is_questioned) {
          field.display = '🚩';
          field.is_flagged = true;
          this.flag_cnt++;
        }
        else if (field.is_flagged) {
          field.display = '❔';
          field.is_flagged = false;
          field.is_questioned = true;
          this.flag_cnt--;
        }
        else {
          field.display = '';
          field.is_questioned = false;
        }
      }
    },

    is_display_bomb(field) {
      return this.is_game_over === 'lose' && field.is_bomb && !field.is_flagged;
    },
  },

  created() {
    this.init();
  },
};
</script>

<style>
.display{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}


</style>